import React, {Component} from 'react'
import PropTypes from 'prop-types'
// import {history} from 'common/store'
import styled from 'styled-components'
import {Dropdown} from 'semantic-ui-react'
import {media} from '../style/utils'

class PreviewSelector extends Component {
  static propTypes = {
    items: PropTypes.array.isRequired,
    // entity: PropTypes.string,
    name: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    this.format = 'jpg'
    this.checkWebp('lossy', (feat, res) => {
      this.format = res ? 'webp' : 'jpg'
    })
  }

  handleKeyUp (event) {
    if (event.keyCode === 13) {
      const template = event.currentTarget.querySelector('.selected > .text').innerText
      this.props.history.push(`../preview/${template}`)
    }
  }

  handleChange (event, data) {
    if (event.currentTarget.innerText) {
      this.props.history.push(`../preview/${event.currentTarget.innerText}`)
    }
  }

  // check_webp_feature:
  //   'feature' can be one of 'lossy', 'lossless', 'alpha' or 'animation'.
  //   'callback(feature, result)' will be passed back the detection result (in an asynchronous way!)
  checkWebp (feature, callback) {
    var kTestImages = {
      lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
      lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
      alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
      animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
    };
    var img = new Image();
    img.onload = function () {
      var result = (img.width > 0) && (img.height > 0);
      callback(feature, result);
    };
    img.onerror = function () {
      callback(feature, false);
    };
    img.src = "data:image/webp;base64," + kTestImages[feature];
  }

  render () {
    const {items, name} = this.props
    let options = []
    let selected = 0

    for (let item of items) {
      let obj = {
        text: item,
        value: item,
        image: `${process.env.REACT_APP_API_URL}/screenshots/${item}.${this.format}`,
      }
      options.push(obj)
      if (item === name) {
        selected = item
      }
    }

    // let icon = /*entity === 'templates' ? 'browser' :*/ 'clone'

    return (
      Object.keys(items).length
        ? <StyledDropdown
          selectOnBlur={false} search inline onKeyUp={this.handleKeyUp.bind(this)}
          options={options} value={selected} onChange={this.handleChange.bind(this)}/>
        : null
    )
  }
}
export const StyledDropdown = styled(Dropdown)`
  margin-right: 1rem !important;
  vertical-align: top !important;
  pointer-events: all;
  margin: 10px 10% !important;
  font-variant-ligatures: none;
  .text, i {
    color: white;
    margin: 0 .5rem;
  }
  & > .text {
    min-width: 120px;
    cursor: pointer !important;
  }
  input:not(:focus).search:hover {
    cursor: pointer !important;
  }
  /*&:after {
    content: '\f0d7';
    font-family: Icons;
    width: 16px;
    height: 16px;
    position: absolute;
    right: 4px;
  }
   .item:first-child {
    display: none !important;
  } */
  &.ui.dropdown .menu {
    position: fixed;
    left: 2px;
    //right: 90vw;
    top: 41px;
    min-height: 50vh;
    max-height: calc(100vh - 46px) !important;
    min-width: 50vw;
    max-width: 1000px;
    padding: 15px 5px 0 !important;
    background-color: rgba(0,0,0,.95);
    padding: 0;
    .item {
      position: relative;
      display: inline-block;
      height: 150px;
      width: 20%;
      padding: 5px !important;
      ${media.md`
        width: 25%;
      `};
      ${media.sm`
        width: 33.3%;
      `};
      &:hover .text {
        opacity: 1;
      }
      &.active .ui.image {
        filter: saturate(1) brightness(.5);
      }
      &.selected .ui.image {
        outline: 4px solid brown;
      }
    }
    .ui.image {
      width: 100% !important;
      max-width: 100% !important;
      max-height: 100% !important;
      height: 100% !important;
      object-position: top;
      object-fit: cover;
    }
    .text {
      position: absolute;
      bottom: 12px;
      left: -2px;
      background-color: rgba(0,0,0,.85);
      right: -2px;
      padding: 5px;
      font-weight: bold;
      opacity: 0;
      transition: opacity .25s;

    }
  }

  /*&.ui.labeled.icon.button {
    padding-left: 3.25em !important;
    padding-right: 2.25em !important;
    .menu {
      /*min-width: max-content;*/
    }
  }*/
`

export default PreviewSelector



// WEBPACK FOOTER //
// ./src/components/PreviewSelector.jsx